import { InputField } from 'components/molecules'

const ProductNameFilterField = () => (
  <>
    <InputField
      name='name'
      label='Name'
      placeholder='Product name'
      type='text'
    />
  </>
)

export default ProductNameFilterField
